import commonUtil from '../../utils/commonUtil';

// CreateEvent Globle JSON Data
export const CREATE_EVENT_OBJECT = 'CREATE_EVENT_OBJECT';
export const CREATE_EVENT = 'CREATE_EVENT';
export const CREATE_EVENT_SUCCESS = 'CREATE_EVENT_SUCCESS';
export const CREATE_EVENT_FAIL = 'CREATE_EVENT_FAIL';
export const CATEGORYSPECIFIC_LOAD = 'CATEGORYSPECIFIC_LOAD';
export const CATEGORYSPECIFIC_SUCCESS = 'CATEGORYSPECIFIC_SUCCESS';
export const CATEGORYSPECIFIC_FAIL = 'CATEGORYSPECIFIC_FAIL';
export const CREATE_EVENT_SESSION = 'CREATE_EVENT_SESSION';
export const COOWNER_PROFILE_ID_LOAD = 'COOWNER_PROFILE_ID_LOAD';
export const COOWNER_PROFILE_ID_LOAD_SUCCESS = 'COOWNER_PROFILE_ID_LOAD_SUCCESS';
export const COOWNER_PROFILE_ID_LOAD_FAIL = 'COOWNER_PROFILE_ID_LOAD_FAIL';
export const CAPTURE_CELEBRITY_TITLE = 'CAPTURE_CELEBRITY_TITLE';

export const isCreateEventDataLoaded = (globalState, pageName) => {
  let status = false;
  status = globalState.createEventObject[pageName] && globalState.createEventObject.loaded;
  return status;
};

export const isCreateEventDataObjLoaded = (globalState) => {
  let status = false;
  status = globalState.createEventObject && globalState.createEventObject.loaded;
  return status;
};

export const getSaveCreateEventData = (pageName, pageDate) => ({
  type: CREATE_EVENT_OBJECT,
  data: pageDate,
});

export function getCoOwnerProfileId(emailId) {
  const _coOwnerEligibility = {};
  _coOwnerEligibility.brandName = commonUtil.getBrand();
  _coOwnerEligibility.channel = commonUtil.getChannel().toUpperCase();
  _coOwnerEligibility.email = emailId;
  return {
    types: [COOWNER_PROFILE_ID_LOAD, COOWNER_PROFILE_ID_LOAD_SUCCESS, COOWNER_PROFILE_ID_LOAD_FAIL],
    promise: client => client.post('/api/currentUser/isProfileVerified', {
      data: (_coOwnerEligibility),
    }),
  };
}

export function getEventSession() {
  const _session = {};
  _session.key = 'createEventSession';
  return {
    types: [CREATE_EVENT, CREATE_EVENT_OBJECT, CREATE_EVENT_FAIL],
    promise: client => client.post('/api/readServerCookie', {
      data: (_session),
    }),
  };
}

export function createEventSession(pageDate) {
  const _session = {};
  _session.key = 'createEventSession';
  _session.data = JSON.stringify(pageDate);
  _session.ttl = '365';

  return {
    types: [CREATE_EVENT, CREATE_EVENT_SESSION, CREATE_EVENT_FAIL],
    promise: client => client.post('/api/createServerCookie', {
      data: (_session),
    }),
  };
}

export const defineCreateEventData = (pageName, pageDate) => (dispatch, getState) => {
  const state = getState();
  const _m = state.createEventObject ? state.createEventObject : {};
  _m[pageName] = pageDate;

  dispatch(getSaveCreateEventData(pageName, _m));
  // dispatch(createEventSession(_m));
};

export function saveUserData(userDetail) {
  const userData = userDetail;
  userData.brand = commonUtil.getBrand();
  userData.channel = commonUtil.getChannel();
  return commonUtil.triggerServerRequest({ url: '/api/createEvent', method: 'POST', data: userData });
}

export function loadCategorySpecificEvents(categoryType, profileId) {
  const _eventCategoryInput = {};
  _eventCategoryInput.brand = commonUtil.getBrand().toUpperCase();
  _eventCategoryInput.channel = commonUtil.getChannel().toUpperCase();
  if (profileId) {
    _eventCategoryInput.profileId = profileId;
  }
  _eventCategoryInput.categoryType = categoryType;
  return {
    types: [CREATE_EVENT, CREATE_EVENT_SUCCESS, CREATE_EVENT_FAIL],
    promise: client => client.post('/api/categorySpecificEvents', {
      data: (_eventCategoryInput),
    }),
  };
}

export function loadCategorySpecificEventsOld(categoryType, profileId) {
  const _eventCategoryInput = {};
  _eventCategoryInput.brand = commonUtil.getBrand().toUpperCase();
  _eventCategoryInput.channel = commonUtil.getChannel().toUpperCase();
  if (profileId) {
    _eventCategoryInput.profileId = profileId;
  }
  _eventCategoryInput.categoryType = categoryType;
  return commonUtil.triggerServerRequest({ url: '/api/categorySpecificEvents', method: 'POST', data: _eventCategoryInput });
}

export const clearEventData = () => (dispatch, getState) => {
  const state = getState();
  const pageDate = state.createEventObject;
  // pageDate.data = {};
  Object.keys(pageDate).map((p) => {
    if (typeof pageDate[p] === 'object' && p !== 'data') {
      delete pageDate[p];
    }
    return undefined;
  });
  // dispatch(getSaveCreateEventData('pageName', pageDate));
  dispatch({
    type: CREATE_EVENT_OBJECT,
    data: pageDate,
  });
};

export const captureCelebrityTitle = (celebrityTitle) => (dispatch) => {
  dispatch({
    type: CAPTURE_CELEBRITY_TITLE,
    celebrityTitle,
  });
}